export interface IHouseFlatCredit {
  houseFlatId: string;
  streetBuildingId: string;
  streetBuildingName: string;
  number: string;
  fullName: string;
  creditBalance: number;
}

export class HouseFlatCredit implements IHouseFlatCredit {
  houseFlatId: string;
  streetBuildingId: string;
  streetBuildingName: string;
  number: string;
  fullName: string;
  creditBalance: number;

  constructor(data: IHouseFlatCredit) {
    this.houseFlatId = data.houseFlatId;
    this.streetBuildingId = data.streetBuildingId;
    this.streetBuildingName = data.streetBuildingName;
    this.number = data.number;
    this.fullName = data.fullName ?? '';
    this.creditBalance = data.creditBalance ?? 0;
  }
}
